import { createGlobalStyle } from '../core';
export default createGlobalStyle `

body.vui-no-scroll {
	overflow: hidden !important;
	overscroll-behavior: contain;
}
`;
